@let isLeftPanelCollapsedValue = isLeftPanelCollapsed();

<div class="left-panel" [class.left-panel--collapsed]="isLeftPanelCollapsedValue">
  <div class="left-panel__navigation-scroll">
    <div class="left-panel__navigation">
      <itc-collapse-button
        [isCollapsed]="isLeftPanelCollapsedValue"
        [label]="'navigation.toggle-navigation' | translate"
        (toggleCollapse)="updateMenuSettings()"
      />
      <itc-left-navigation />
    </div>
  </div>
  @if (!isMigratedUser) {
    <div *itcPermission="Permission.AccountTeamView" class="left-panel__footer">
      @if (isLeftPanelCollapsedValue) {
        <itc-managers-button (click)="updateMenuSettings()" />
      } @else {
        <itc-account-team-panel />
      }
    </div>
  }
</div>
